import React from 'react';

//Presentational component to display a note with special styling treatment.
//Pass in a heading and a message via props. 
function CalloutNotice(props){
  const heading = props.heading;
  const message = props.message;
  
  const msgMarkup = message.split('\n').map((str, index) => <p key={index} className='aa-callout-msg'>{str}</p>);
  return(
    <div className="aa-callout">
      <h4><i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> {heading}</h4>
      {msgMarkup}
    </div>
  );
}

export default CalloutNotice;

